/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Files_ErrorInputs */

const en_us2_builds_files_error = /** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files could not be loaded`)
};

const es_es2_builds_files_error = /** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar los archivos`)
};

const ru_builds_files_error = /** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить файлы`)
};

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const id_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const ms_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const da_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const de_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const es_mx2_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const fil_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const fr_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const it_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const hu_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const nl_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const no_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const pl_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const pt_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const pt_br2_builds_files_error = pt_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const ro_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const fi_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const sv_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const vi_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const tr_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const cs_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const bg_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const uk_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const ar_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const hi_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const th_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const ja_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const zh_cn2_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const zh_hant1_builds_files_error = en_us2_builds_files_error;

/** @type {(inputs: Builds_Files_ErrorInputs) => LocalizedString} */
const ko_builds_files_error = en_us2_builds_files_error;

/**
* | output |
* | --- |
* | "Files could not be loaded" |
*
* @param {Builds_Files_ErrorInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_files_error = /** @type {((inputs?: Builds_Files_ErrorInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Files_ErrorInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_files_error(inputs)
	if (locale === "ms") return ms_builds_files_error(inputs)
	if (locale === "da") return da_builds_files_error(inputs)
	if (locale === "de") return de_builds_files_error(inputs)
	if (locale === "en-US") return en_us2_builds_files_error(inputs)
	if (locale === "es-ES") return es_es2_builds_files_error(inputs)
	if (locale === "es-MX") return es_mx2_builds_files_error(inputs)
	if (locale === "fil") return fil_builds_files_error(inputs)
	if (locale === "fr") return fr_builds_files_error(inputs)
	if (locale === "it") return it_builds_files_error(inputs)
	if (locale === "hu") return hu_builds_files_error(inputs)
	if (locale === "nl") return nl_builds_files_error(inputs)
	if (locale === "no") return no_builds_files_error(inputs)
	if (locale === "pl") return pl_builds_files_error(inputs)
	if (locale === "pt-BR") return pt_br2_builds_files_error(inputs)
	if (locale === "pt") return pt_builds_files_error(inputs)
	if (locale === "ro") return ro_builds_files_error(inputs)
	if (locale === "fi") return fi_builds_files_error(inputs)
	if (locale === "sv") return sv_builds_files_error(inputs)
	if (locale === "vi") return vi_builds_files_error(inputs)
	if (locale === "tr") return tr_builds_files_error(inputs)
	if (locale === "cs") return cs_builds_files_error(inputs)
	if (locale === "bg") return bg_builds_files_error(inputs)
	if (locale === "ru") return ru_builds_files_error(inputs)
	if (locale === "uk") return uk_builds_files_error(inputs)
	if (locale === "ar") return ar_builds_files_error(inputs)
	if (locale === "hi") return hi_builds_files_error(inputs)
	if (locale === "th") return th_builds_files_error(inputs)
	if (locale === "ja") return ja_builds_files_error(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_files_error(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_files_error(inputs)
	return ko_builds_files_error(inputs)
});
export { builds_files_error as "builds.files.error" }